// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maxwidth {\n  max-width: 200px;\n}\n.today-check-container {\n  height: 35px;\n}\n.today-check {\n  margin-left: 4px;\n}\n.filter-radio-buttons {\n  height: 35px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.filter-radio-buttons .radio-group-class {\n  top: 2px;\n}\n.date-height {\n  height: 35px !important;\n}\n@media only screen and (max-width: 768px) {\n.date-height {\n    height: auto !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
